<template>
	<div v-if="details" class="c-meta-info-bar">
		<!-- DESKTOP -->
		<div
			class="
				c-meta-info-bar__content
				hidden
				>=768:flex
				items-center
				py-3xs/v
				px-layout-margin
				h-92
				relative
			"
		>
			<!-- SOCIAL MEDIA -->
			<div
				v-if="
					(details.altLanguageProfile &&
						details.altLanguageProfile.Url) ||
					(details.social &&
						details.social.items &&
						details.social.items.length > 0)
				"
				class="
					flex
					text-white
					justify-center
					items-center
					mr-92
					flex-shrink-0
				"
			>
				<BaseButton
					v-if="
						details.altLanguageProfile &&
						details.altLanguageProfile.Url
					"
					tag="NuxtLinkExt"
					:to="details.altLanguageProfile.Url"
					:lang="englishLayout ? 'da' : 'en'"
					class="
						flex-shrink-0
						border border-white
						mr-4xs/h
						h-40
						text-body-xs
						whitespace-nowrap
					"
				>
					{{ englishLayout ? 'Dansk' : 'English' }}
				</BaseButton>

				<a
					v-for="(item, index) in details.social &&
					details.social.items"
					:key="`meta-info-bar-social-${index}`"
					:href="item.url"
					:target="item.target"
					class="
						text-label
						underline
						rounded-full
						hover:bg-theme-90
						transition-colors
						duration-200
						mr-4xs/h
					"
				>
					<SvgIconOrcid
						v-if="item.type === 'orchid'"
						class="w-40 h-40 border-white border rounded-full"
					/>
					<SvgIconTwitter
						v-if="item.type === 'twitter'"
						class="
							w-40
							h-40
							border-white border
							py-4xs/v
							rounded-full
						"
					/>
					<SvgIconFacebook
						v-if="item.type === 'facebook'"
						class="
							w-40
							h-40
							border-white border
							py-4xs/v
							rounded-full
						"
					/>
					<SvgIconLinkedin
						v-if="item.type === 'linkedin'"
						class="
							w-40
							h-40
							border-white border
							py-4xs/v
							rounded-full
						"
					/>
					<SvgIconWebsite
						v-if="item.type === 'personal'"
						class="
							w-40
							h-40
							border-white border
							py-5xs/v
							rounded-full
						"
					/>
				</a>
			</div>
			<!-- CONTACTS -->
			<div class="text-white mr-92 flex flex-col">
				<a
					v-if="details.phone"
					:href="details.phone.link"
					class="text-body-xs underline"
					v-text="details.phone.text"
				></a>
				<a
					v-if="details.email"
					:href="details.email.link"
					class="text-body-xs underline"
					v-text="details.email.text"
				></a>
			</div>
			<!-- DEPARTMENTS -->
			<div class="text-white flex flex-col mr-92">
				<div
					v-for="(department, index) in details.departments"
					:key="`meta-info-bar-department-${index}`"
					class="uppercase text-body-xs font-small"
				>
					{{ department.name }}
				</div>

				<div
					v-if="details.location && details.location.name"
					class="uppercase text-body-xs font-small"
				>
					{{ details.location.name }}
				</div>
			</div>
			<!-- DONWLOAD BUTTON -->
			<div
				v-if="details.links.items && details.links.items.length > 0"
				class="ml-auto"
			>
				<LinkDropdown
					:links="details.links.items"
					:label="details.links.label"
					:description="details.links.description"
					class="h-40"
				/>
			</div>
		</div>
		<!-- MOBILE -->

		<div
			class="hidden <768:flex flex-col c-meta-info-bar__content relative"
		>
			<div
				class="
					flex flex-col
					gap-3xs/v
					bg-theme
					py-2xs/v
					text-theme-text
					px-layout-margin
					h-fit
					relative
				"
			>
				<!-- DEPARTMENTS -->
				<div class="text-red flex flex-col gap-4">
					<div
						v-for="(department, index) in details.departments"
						:key="`meta-info-bar-department-${index}`"
						class="uppercase text-label-sm font-small"
					>
						{{ department.name }}
					</div>

					<div
						v-if="details.location && details.location.name"
						class="uppercase text-label-sm font-small"
					>
						{{ details.location.name }}
					</div>
				</div>

				<!-- SOCIAL MEDIA -->
				<div
					v-if="details.social && details.social.items.length > 0"
					class="
						flex
						text-red
						justify-center
						items-center
						w-fit
						-mx-2
						self-end
						flex-shrink-0
					"
				>
					<BaseButton
						v-if="
							details.altLanguageProfile &&
							details.altLanguageProfile.Url
						"
						tag="NuxtLinkExt"
						:to="details.altLanguageProfile.Url"
						class="
							flex-shrink-0
							bg-gray-light
							border border-theme
							text-theme
							ml-5xs/h
							h-40
							text-body-xs
							whitespace-nowrap
						"
					>
						{{ englishLayout ? 'Danish' : 'English' }}
					</BaseButton>

					<a
						v-for="(item, index) in details.social.items"
						:key="`meta-info-bar-social-${index}`"
						:href="item.url"
						:target="item.target"
						class="text-label underline"
					>
						<SvgIconOrcid
							v-if="item.type === 'orchid'"
							class="
								w-40
								h-40
								border-red border
								rounded-full
								ml-5xs/h
							"
						/>
						<SvgIconTwitter
							v-if="item.type === 'twitter'"
							class="
								w-40
								h-40
								border-red border
								hover:bg-theme-90
								transition-colors
								duration-200
								py-4xs/v
								rounded-full
								ml-5xs/h
							"
						/>
						<SvgIconFacebook
							v-if="item.type === 'facebook'"
							class="
								w-40
								h-40
								border-red border
								hover:bg-theme-90
								transition-colors
								duration-200
								py-4xs/v
								ml-5xs/h
								rounded-full
							"
						/>
						<SvgIconLinkedin
							v-if="item.type === 'linkedin'"
							class="
								w-40
								h-40
								border-red
								borde
								r
								hover:bg-theme-90
								transition-colors
								duration-200
								py-4xs/v
								ml-5xs/h
								rounded-full
							"
						/>
						<SvgIconWebsite
							v-if="item.type === 'personal'"
							class="
								w-40
								h-40
								border-red border
								hover:bg-theme-90
								transition-colors
								duration-200
								py-5xs/v
								ml-5xs/h
								rounded-full
							"
						/>
					</a>
				</div>
			</div>
			<div
				class="
					c-meta-info-bar
					bg-red
					py-3xs/v
					px-layout-margin
					h-92
					flex
					items-center
					relative
				"
			>
				<!-- CONTACTS -->
				<div class="text-white mr-20">
					<div v-if="details.phone">
						<a
							:href="details.phone.link"
							class="text-label underline"
							v-text="details.phone.text"
						></a>
					</div>
					<div v-if="details.email">
						<a
							:href="details.email.link"
							class="text-label underline"
							v-text="details.email.text"
						></a>
					</div>
				</div>
				<!-- DONWLOAD BUTTON -->
				<div
					v-if="details.links.items && details.links.items.length > 0"
					class="ml-auto"
				>
					<LinkDropdown
						:links="details.links.items"
						:label="details.links.label"
						:description="details.links.description"
						class="h-40 text-body-xs"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import BaseButton from '~/components/main/Base/BaseButton';
import LinkDropdown from '~/components/main/LinkDropdown';
import SvgIconOrcid from '~/assets/svgs/icon-orcid.svg?inline';
import SvgIconFacebook from '~/assets/svgs/icon-facebook.svg?inline';
import SvgIconLinkedin from '~/assets/svgs/icon-linkedin.svg?inline';
import SvgIconTwitter from '~/assets/svgs/icon-twitter.svg?inline';
import SvgIconWebsite from '~/assets/svgs/icon-website.svg?inline';

export default {
	name: 'MetaInfoBar',
	components: {
		SvgIconOrcid,
		SvgIconFacebook,
		SvgIconLinkedin,
		SvgIconTwitter,
		SvgIconWebsite,

		LinkDropdown,
		BaseButton,
	},
	props: {
		details: {
			type: Object,
			required: false,
		},
		englishLayout: {
			type: Boolean,
			default: false,
		},
	},

	data() {
		return {
			isButtonOpen: false,
		};
	},
	methods: {
		toggleButton() {
			this.isButtonOpen = !this.isButtonOpen;
		},
	},
};
</script>
<style lang="postcss">
.c-meta-info-bar__content:before {
	@apply absolute bg-red;
	content: '';
	left: calc(var(--margin, 0px) * -1);
	top: 0;
	width: calc(100% + var(--margin, 0px) * 2);
	height: 100%;
	z-index: -1;
}

@screen >=1441 {
	.c-meta-info-bar__content {
		--margin: (
				var(--visual-viewport-width, 100vw) -
					var(--theme-layout-max, 1440px)
			) / 2;
	}
}
</style>
